import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@base/environments/environment';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { RrhhAgentDetail, RrhhAgentList } from 'src/app/models/rrhh.model';
import { TableHeader } from 'src/app/models/tableheader.model';
import { UtilsService } from 'src/app/services/utils.service';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-rrhh-agents-tab',
  templateUrl: './rrhh-agents-tab.component.html',
  styleUrls: ['./rrhh-agents-tab.component.scss'],
})
export class RrhhAgentsTabComponent implements OnChanges {
  @Input() tableHeader: TableHeader[] = [];
  @Input() agentList: RrhhAgentList[] = [];
  @Input() agentDetail: RrhhAgentDetail | undefined;
  @Input() typeAntiquity: string = '';
  /** Id de agente a expandir automáticamente (navegación desde Teams). */
  @Input() expandAgentId: number | null = null;
  @Output() seeDetailAgent: EventEmitter<any> = new EventEmitter<any>();
  @Input() isLoadingAgentDetail!: boolean;
  @Input() userCurrency: any;
  @Output() seeDialogRemoveAgent: EventEmitter<any> = new EventEmitter<any>();
  /** Navegar al team del agente (pestaña Teams). */
  @Output() goToTeam = new EventEmitter<{ teamId: number; teamName: string }>();
  isLoadingAgentDetail2 = true;

  readonly ANTIQUITY_RMX = 'Antigüedad RMX';
  readonly ANTIQUITY_QR = 'Antigüedad QR';

  buttonEdit: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true,
  };

  buttonExpand: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.EXPAND_MORE,
    iconOnly: true,
  };

  buttonModif: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Modificar',
    icon: Constants.ICONS.PENCIL_BLUE,
  };

  buttonRemoveAgent: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Baja RMX',
    icon: Constants.ICONS.AGENT_REMOVE,
  };

  buttonClosures: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Ver consolidado',
  };

  //Detalle agente
  itemExpand: null | number = null;

  readonly NODE: string = environment.node;
  readonly NODE_AR: string = Constants.TENANT_ID_AR;
  readonly NODE_EC: string = Constants.TENANT_ID_EC;

  //any porque los nodos son dinámicos (vienen del env en la ejecución) y TS requiere key estaticas que consume en tiempo de compilacion
  typeAgents: any = {
    ar: {
      RAPP: 'RAPP',
      ALTO: 'ALTO',
      PURO: 'PURO',
      TEAM_JUNIOR: 'TEAM MEMBER',
    },
    ec: {
      CINCUENTA_PORCIENTO: '50%',
      SESENTA_PORCIENTO: '60%',
      SETENTA_PORCIENTO: '70%',
      OCHENTA_PORCIENTO: '80%',
      NOVENTA_PORCIENTO: '90%',
      CIEN_PORCIENTO: '100%',
    },
    py: {
      RAPP40: 'RAPP',
      RAPP: 'INICIAL',
      ALTO: 'ALTO',
      PURO: 'PURO',
    },
    global: {
      RAPP: 'RAPP',
      ALTO: 'ALTO',
      PURO: 'PURO',
      AGENTE_CIEN_PORCIENTO: '100%',
      TEAM_JUNIOR: 'TEAM MEMBER',
    },
    do: {
      SPLIT_50: '50%',
      SPLIT_55: '55%',
      SPLIT_60: '60%',
      SPLIT_65: '65%',
      SPLIT_70: '70%',
      SPLIT_75: '75%',
      SPLIT_80: '80%',
      SPLIT_85: '85%',
      SPLIT_90: '90%',
      SPLIT_95: '95%',
      SPLIT_100: '100%',
    },
  };

  readonly ICON_ARROW_RIGHT_UP = Constants.ICONS.ARROW_RIGHT_UP;

  constructor(
    private readonly utils: UtilsService,
    private readonly router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['expandAgentId'] || changes['agentList']) &&
      this.expandAgentId != null &&
      this.agentList?.length
    ) {
      const INDEX = this.agentList.findIndex(
        (a) => a.id === this.expandAgentId
      );
      if (INDEX >= 0 && this.itemExpand !== INDEX) {
        this.itemExpand = INDEX;
        this.seeDetailAgent.emit(this.agentList[INDEX].id);
      }
    }
  }

  onExpandItem(i: number) {
    this.itemExpand = this.itemExpand == i ? null : i;
    if (this.itemExpand != null) {
      this.seeDetailAgent.emit(this.agentList[i].id);
    }
  }

  /** Emite navegación al team del agente (matching por id, no por nombre). */
  onGoToTeam(): void {
    const TEAM_ID = Number(this.agentDetail?.teamId);
    const TEAM_NAME = this.agentDetail?.teamName;
    if (!TEAM_ID || !TEAM_NAME) {
      return;
    }
    this.goToTeam.emit({ teamId: TEAM_ID, teamName: TEAM_NAME });
  }

  buttonRemoveAgentClick() {
    if (
      this.agentDetail?.statusRMX == 'Activo' &&
      !(
        this.agentDetail?.rauRequest?.type == 'Baja' &&
        this.agentDetail?.rauRequest?.state == 'Pendiente'
      )
    ) {
      this.seeDialogRemoveAgent.emit();
    }
  }

  //Validar si el elem. existe sino imprime un guión
  print(e: any) {
    return e ?? '-';
  }

  formatNumber(n: any): string {
    return this.utils.processNumberAddDotFormat(n);
  }

  onModify(id: number) {
    if (id) this.router.navigate(['/rrhh/edit/' + id]);
  }

  formatWhatsapp(num: InputTypes): string {
    let numFormatted = '';
    if (num) {
      numFormatted = num.toString();
      numFormatted = numFormatted
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll('-', '')
        .replaceAll(' ', '');
    } else {
      numFormatted = '-';
    }
    return numFormatted;
  }

  printAgentType(typeIn?: string): string {
    const TYPE = typeIn ?? this.agentDetail?.agentType ?? '';
    return this.typeAgents[environment.node][TYPE] ?? '-';
  }

  formatAgentLevel(value?: string): string {
  if (!value) return '';

  const TRIMMED = value.trim();

  if (TRIMMED === '-') return '-';

  const LOWER = TRIMMED.toLowerCase();
  return LOWER.charAt(0).toUpperCase() + LOWER.slice(1);
}
}
